'use client';
import React, { useState, useMemo } from 'react';

interface Article {
  id: number;
  category: string;
  categoryColor: string;
  date: string;
  title: string;
  excerpt: string;
  image: string;
  alt: string;
  href: string;
  type: 'news' | 'blog' | 'event' | 'press';
}

const ALL_ARTICLES: Article[] = [
{
  id: 1,
  category: 'Thought Leadership',
  categoryColor: '#00b195',
  date: '04.21.2026',
  title: 'What Faith Organizations Should Consider When Repurposing Real Estate for Housing',
  excerpt:
  'As faith communities across the country grapple with underutilized properties, Brickwell Housing explores the unique opportunity to convert sacred spaces into vibrant, affordable residential communities.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1214b31d7-1777272191954.png",
  alt: 'Historic stone church building with stained glass windows being considered for adaptive reuse as affordable housing',
  href: '#media',
  type: 'blog'
},
{
  id: 2,
  category: 'News',
  categoryColor: '#00b9f2',
  date: '04.15.2026',
  title: 'Brickwell Housing Celebrates Ribbon Cutting at Sunrise Terrace Affordable Community',
  excerpt:
  'Residents, city officials, and community partners gathered in Sacramento to celebrate the grand opening of Sunrise Terrace, a 96-unit affordable housing development serving working families.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_12092ff3a-1776892894349.png",
  alt: 'Ribbon cutting ceremony at Sunrise Terrace affordable housing community with officials and new residents celebrating',
  href: '#media',
  type: 'news'
},
{
  id: 3,
  category: 'Press Release',
  categoryColor: '#003c82',
  date: '04.08.2026',
  title: 'Brickwell Housing Secures $42M in Tax Credit Financing for New Workforce Development',
  excerpt:
  'Brickwell Housing announced today the successful closing of $42 million in Low-Income Housing Tax Credit financing for the development of 150 workforce housing units in the San Fernando Valley.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1afef0dbf-1776892893996.png",
  alt: 'Financial documents and handshake representing successful tax credit financing deal for affordable housing development',
  href: '#media',
  type: 'press'
},
{
  id: 4,
  category: 'Event',
  categoryColor: '#f05323',
  date: '03.28.2026',
  title: 'Brickwell Housing to Host Annual Affordable Housing Summit — Register Now',
  excerpt:
  'Join Brickwell Housing and industry leaders for our Annual Affordable Housing Summit on June 12, 2026 in Los Angeles. This year’s theme: “Building Resilient Communities for the Next Generation.”',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c373a59f-1772994411802.png",
  alt: 'Conference hall with attendees at an affordable housing summit with speakers on stage',
  href: '#media',
  type: 'event'
},
{
  id: 5,
  category: 'Thought Leadership',
  categoryColor: '#00b195',
  date: '03.14.2026',
  title: 'Five Design Principles That Make Affordable Housing Feel Like Home',
  excerpt:
  "Great affordable housing isn't just about units — it's about dignity, community, and belonging. Brickwell's design team shares the five principles that guide every project from concept to completion.",
  image: "https://images.unsplash.com/photo-1727714160599-b3ba58e558e5",
  alt: 'Modern affordable housing interior with bright living room, quality finishes, and welcoming design elements',
  href: '#media',
  type: 'blog'
},
{
  id: 6,
  category: 'News',
  categoryColor: '#00b9f2',
  date: '03.05.2026',
  title: 'Brickwell Housing Partners with City of Oakland on 200-Unit Mixed-Income Development',
  excerpt:
  'Brickwell Housing and the City of Oakland announced a landmark partnership to develop 200 mixed-income housing units in the Fruitvale district, with 60% reserved for households earning below 60% AMI.',
  image: "https://images.unsplash.com/photo-1520441199865-d2ad3286f18b",
  alt: 'Oakland city skyline with residential buildings and the Bay Bridge in the background',
  href: '#media',
  type: 'news'
},
{
  id: 7,
  category: 'Press Release',
  categoryColor: '#003c82',
  date: '02.20.2026',
  title: 'Brickwell Housing Named Among Top 10 Affordable Housing Developers in the Western U.S.',
  excerpt:
  'For the third consecutive year, Brickwell Housing has been recognized by Housing Finance Magazine as one of the top 10 affordable housing developers in the Western United States.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_11539644e-1777272191654.png",
  alt: 'Award trophy and certificate recognizing Brickwell Housing as a top affordable housing developer',
  href: '#media',
  type: 'press'
},
{
  id: 8,
  category: 'Thought Leadership',
  categoryColor: '#00b195',
  date: '02.10.2026',
  title: 'The Role of Supportive Services in Long-Term Housing Stability',
  excerpt:
  "Housing is more than four walls — it's a foundation for health, education, and economic mobility. Brickwell's resident services team explores how wraparound support transforms housing outcomes.",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1509f3d12-1772145967347.png",
  alt: 'Community services coordinator meeting with residents in a bright, welcoming community room',
  href: '#media',
  type: 'blog'
},
{
  id: 9,
  category: 'News',
  categoryColor: '#00b9f2',
  date: '01.28.2026',
  title: 'Brickwell Housing Completes Renovation of Historic Westside Apartments, Preserving 84 Affordable Units',
  excerpt:
  'After 18 months of comprehensive renovation, Brickwell Housing has completed the rehabilitation of the historic Westside Apartments, preserving 84 affordable units and adding modern amenities for residents.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_105c1b48f-1772201519898.png",
  alt: 'Renovated historic apartment building exterior with new windows, landscaping, and modern facade improvements',
  href: '#media',
  type: 'news'
},
{
  id: 10,
  category: 'Event',
  categoryColor: '#f05323',
  date: '01.15.2026',
  title: 'Brickwell Housing Resident Appreciation Day — Celebrating Our Communities Across California',
  excerpt:
  'Brickwell Housing hosted its annual Resident Appreciation Day across 12 communities, bringing together residents, staff, and local partners for a day of celebration, resources, and connection.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b40395b9-1767037512705.png",
  alt: 'Residents and staff gathered outdoors at a community appreciation event with balloons and tables',
  href: '#media',
  type: 'event'
},
{
  id: 11,
  category: 'Press Release',
  categoryColor: '#003c82',
  date: '01.06.2026',
  title: 'Brickwell Housing Announces $120M Pipeline of New Affordable Developments for 2026',
  excerpt:
  'Brickwell Housing enters 2026 with a robust pipeline of 8 new affordable housing developments totaling over 900 units across California, Nevada, and Arizona, representing $120 million in total investment.',
  image: "https://images.unsplash.com/photo-1655045850845-1663631c2580",
  alt: 'Modern affordable housing development under construction with cranes and building framework visible',
  href: '#media',
  type: 'press'
},
{
  id: 12,
  category: 'Thought Leadership',
  categoryColor: '#00b195',
  date: '12.18.2024',
  title: 'Navigating the Affordable Housing Finance Landscape in 2026: What Developers Need to Know',
  excerpt:
  'With shifting interest rates, evolving tax credit markets, and new federal programs on the horizon, Brickwell Housing’s finance team breaks down what affordable housing developers need to know heading into 2026.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d805da11-1772722619306.png",
  alt: 'Financial charts and graphs on a laptop screen showing housing market data and investment trends',
  href: '#media',
  type: 'blog'
}];


const CATEGORIES = ['All Categories', 'News', 'Thought Leadership', 'Press Release', 'Event'];
const ITEMS_PER_PAGE = 9;

export default function MediaCenterArticles() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All Categories');
  const [currentPage, setCurrentPage] = useState(1);
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const filtered = useMemo(() => {
    return ALL_ARTICLES.filter((a) => {
      const matchesSearch =
      searchQuery === '' ||
      a.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      a.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesCategory =
      selectedCategory === 'All Categories' || a.category === selectedCategory;
      return matchesSearch && matchesCategory;
    });
  }, [searchQuery, selectedCategory]);

  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
  const paginated = filtered.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setCurrentPage(1);
  };

  const handleCategoryChange = (cat: string) => {
    setSelectedCategory(cat);
    setCurrentPage(1);
  };

  const getPageNumbers = (): (number | string)[] => {
    const pages: (number | string)[] = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (
      let i = Math.max(2, currentPage - 1);
      i <= Math.min(totalPages - 1, currentPage + 1);
      i++)
      {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const navBtnBase: React.CSSProperties = {
    padding: '5px 10px',
    backgroundColor: '#003c82',
    color: '#ffffff',
    border: 'none',
    borderRadius: '0',
    fontSize: '16px',
    cursor: 'pointer',
    fontFamily: 'Montserrat, sans-serif',
    lineHeight: '22px',
    transition: 'background-color 0.2s ease'
  };

  return (
    <section
      style={{
        padding: '50px 0 64px',
        backgroundColor: '#ffffff'
      }}>

      <div
        style={{
          maxWidth: '1280px',
          margin: '0 auto',
          padding: '0 20px'
        }}>

        {/* Filter Bar */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            marginBottom: '40px',
            flexWrap: 'wrap'
          }}>

          {/* Search */}
          <form
            onSubmit={handleSearch}
            style={{
              position: 'relative',
              width: '100%',
              maxWidth: '280px',
              flexShrink: 0
            }}
            className="filter-search">

            <input
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setCurrentPage(1);
              }}
              style={{
                width: '100%',
                height: '48px',
                padding: '4px 46px 0 16px',
                border: '1px solid #ebedee',
                borderRadius: '0',
                fontSize: '14px',
                color: '#003c82',
                backgroundColor: '#ffffff',
                fontFamily: 'Montserrat, sans-serif',
                outline: 'none',
                boxSizing: 'border-box'
              }} />

            <button
              type="submit"
              style={{
                position: 'absolute',
                right: '0',
                top: '0',
                height: '48px',
                width: '48px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#003c82'
              }}
              aria-label="Search">

              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">

                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
            </button>
          </form>

          {/* Category Filter */}
          <div
            style={{
              position: 'relative',
              width: '100%',
              maxWidth: '280px',
              flexShrink: 0
            }}
            className="filter-select">

            <select
              value={selectedCategory}
              onChange={(e) => handleCategoryChange(e.target.value)}
              style={{
                width: '100%',
                height: '48px',
                padding: '0 40px 0 16px',
                backgroundColor: '#efefef',
                border: 'none',
                borderRadius: '0',
                fontSize: '14px',
                color: '#49454f',
                fontFamily: 'Montserrat, sans-serif',
                cursor: 'pointer',
                appearance: 'none',
                outline: 'none',
                boxSizing: 'border-box'
              }}>

              {CATEGORIES.map((cat) =>
              <option key={cat} value={cat}>
                  {cat}
                </option>
              )}
            </select>
            <div
              style={{
                position: 'absolute',
                right: '14px',
                top: '50%',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
                color: '#49454f'
              }}>

              <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                <path
                  d="M1 1l5 5 5-5"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round" />

              </svg>
            </div>
          </div>

          {(searchQuery || selectedCategory !== 'All Categories') &&
          <span
            style={{
              fontSize: '14px',
              color: '#888',
              fontFamily: 'Montserrat, sans-serif'
            }}>

              {filtered.length} result{filtered.length !== 1 ? 's' : ''} found
            </span>
          }
        </div>

        {/* Articles Grid */}
        {paginated.length > 0 ?
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '48px 24px'
          }}
          className="articles-grid">

            {paginated.map((article) =>
          <article
            key={article.id}
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
            onMouseEnter={() => setHoveredCard(article.id)}
            onMouseLeave={() => setHoveredCard(null)}>

                <figure
              style={{
                margin: '0 0 16px',
                overflow: 'hidden',
                position: 'relative'
              }}>

                  <a href={article.href} style={{ display: 'block' }}>
                    <img
                  src={article.image}
                  alt={article.alt}
                  style={{
                    width: '100%',
                    height: '220px',
                    objectFit: 'cover',
                    display: 'block',
                    transition: 'transform 0.4s ease',
                    transform: hoveredCard === article.id ? 'scale(1.05)' : 'scale(1)'
                  }} />

                  </a>
                </figure>

                <header
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '10px',
                fontFamily: 'Montserrat, sans-serif'
              }}>

                  <a
                href={article.href}
                style={{
                  fontSize: '14px',
                  fontWeight: 500,
                  color: article.categoryColor,
                  textDecoration: 'none',
                  transition: 'opacity 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLAnchorElement).style.opacity = '0.75';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLAnchorElement).style.opacity = '1';
                }}>

                    {article.category}
                  </a>
                  <time
                dateTime={article.date}
                style={{
                  fontSize: '14px',
                  color: '#888888'
                }}>

                    {article.date}
                  </time>
                </header>

                <h3
              style={{
                fontSize: '20px',
                fontWeight: 400,
                color: '#333333',
                lineHeight: '24px',
                margin: '0 0 16px',
                fontFamily: 'Montserrat, sans-serif',
                flexGrow: 1
              }}>

                  <a
                href={article.href}
                style={{
                  color: 'inherit',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLAnchorElement).style.color = '#003c82';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLAnchorElement).style.color = '#333333';
                }}>

                    {article.title}
                  </a>
                </h3>

                <p
              style={{
                fontSize: '14px',
                color: '#555555',
                lineHeight: '20px',
                margin: '0 0 16px',
                fontFamily: 'Montserrat, sans-serif',
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden'
              }}>

                  {article.excerpt}
                </p>

                <a
              href={article.href}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                color: '#003c82',
                fontSize: '14px',
                fontWeight: 600,
                textDecoration: 'none',
                fontFamily: 'Montserrat, sans-serif',
                marginTop: 'auto',
                transition: 'color 0.2s ease'
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLAnchorElement).style.color = '#6dcff6';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLAnchorElement).style.color = '#003c82';
              }}>

                  Read More
                  <svg width="8" height="14" viewBox="0 0 8 14" fill="none">
                    <path
                  d="M1 1l6 6-6 6"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round" />

                  </svg>
                </a>
              </article>
          )}
          </div> :

        <div
          style={{
            textAlign: 'center',
            padding: '80px 20px',
            color: '#888',
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '16px'
          }}>

            No articles found matching your search.
          </div>
        }

        {/* Pagination */}
        {totalPages > 1 &&
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px',
            marginTop: '60px',
            flexWrap: 'wrap'
          }}>

            {currentPage > 1 &&
          <button
            onClick={() => setCurrentPage(currentPage - 1)}
            style={navBtnBase}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#01abe0';
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#003c82';
            }}>

                &lsaquo;
              </button>
          }

            {getPageNumbers().map((page, idx) =>
          typeof page === 'string' ?
          <span
            key={`dots-${idx}`}
            style={{
              padding: '5px 10px',
              backgroundColor: '#003c82',
              color: '#ffffff',
              fontSize: '16px',
              fontFamily: 'Montserrat, sans-serif',
              lineHeight: '22px',
              display: 'inline-block'
            }}>

                  &hellip;
                </span> :

          <button
            key={page}
            onClick={() => setCurrentPage(page as number)}
            style={{
              ...navBtnBase,
              backgroundColor: currentPage === page ? '#01abe0' : '#003c82',
              fontWeight: currentPage === page ? 600 : 400
            }}
            onMouseEnter={(e) => {
              if (currentPage !== page) {
                (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#01abe0';
              }
            }}
            onMouseLeave={(e) => {
              if (currentPage !== page) {
                (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#003c82';
              }
            }}>

                  {page}
                </button>

          )}

            {currentPage < totalPages &&
          <button
            onClick={() => setCurrentPage(currentPage + 1)}
            style={navBtnBase}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#01abe0';
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#003c82';
            }}>

                &rsaquo;
              </button>
          }
          </div>
        }
      </div>

      <style>{`
        @media (max-width: 1024px) {
          .articles-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 40px 20px !important;
          }
        }
        @media (max-width: 768px) {
          .filter-search,
          .filter-select {
            max-width: 100% !important;
            width: 100% !important;
          }
        }
        @media (max-width: 640px) {
          .articles-grid {
            grid-template-columns: 1fr !important;
            gap: 36px 0 !important;
          }
        }
      `}</style>
    </section>);

}